import { Avatar } from '@air/primitive-avatar';
import { formatFullName, formatInitials } from '@air/utilities';
import { cn } from '@air/utils-tailwind';

import { SelectChipRemoveButton } from '~/components/Select/components/SelectChipRemoveButton';
import { type UploaderOption } from '~/components/Selects/Uploader/utils';
import { getAvatarImageSrc } from '~/utils/getAvatarImageSrc';

export type UploaderChipProps = {
  uploader: UploaderOption;
  className?: string;
  onRemoveUploader?: (uploader: UploaderOption) => void;
};

export const UploaderChip = ({
  uploader,
  uploader: { id, avatar, firstName, lastName },
  className,
  onRemoveUploader,
}: UploaderChipProps) => {
  return (
    <div className={cn('flex items-center rounded-full bg-grey-3 p-0.5 pr-1.5', className)}>
      <Avatar
        appearance="circle"
        size={20}
        src={getAvatarImageSrc(avatar, 20)}
        text={formatInitials(firstName, lastName)}
        colorSeed={id}
      />
      <div className="mr-0.5 ml-1 truncate font-medium text-12 text-grey-12">{formatFullName(firstName, lastName)}</div>
      {onRemoveUploader && <SelectChipRemoveButton chip={uploader} onClick={onRemoveUploader} />}
    </div>
  );
};
